import React, { createContext, useState, useContext, useRef, useEffect } from 'react';
import { bumpIntakeButton } from '../../Button/ButtonAnimation';

const SelectedServicesContext = createContext();

export const SelectedServicesProvider = ({ children }) => {
  const [selectedServices, setSelectedServices] = useState([]);
  const intakeButtonRef = useRef(null);

  const addService = (service) => {
    setSelectedServices(prev => {
      const newServices = [...prev, service];
      if (newServices.length > prev.length) {
        setTimeout(() => bumpIntakeButton(intakeButtonRef.current), 100);
      }
      return newServices;
    });
  };

  const removeService = (serviceToRemove) => {
    setSelectedServices(prev => prev.filter(service => service !== serviceToRemove));
  };

  useEffect(() => {
    const button = document.querySelector('.book-intake-button');
    if (button) {
      intakeButtonRef.current = button;
    }
  }, []);

  return (
    <SelectedServicesContext.Provider value={{ 
      selectedServices, 
      addService, 
      removeService
    }}>
      {children}
    </SelectedServicesContext.Provider>
  );
};

export const useSelectedServices = () => useContext(SelectedServicesContext);
